<script setup lang="ts">
import { computed } from 'vue'
import type { Attachment } from '~/types/blog'
import { getAttachmentName } from '~/utils/attachments'
import { resolveAssetUrl } from '~/composables/useAssetUrl'

const props = defineProps<{
  attachments?: Attachment[] | null
  title?: string
}>()
const sectionTitle = computed(() => props.title || '附件下载')

const files = computed(() => props.attachments || [])
</script>

<template>
  <section v-if="files.length" class="attachment-downloads">
    <h3>
      <i class="fa-solid fa-link" aria-hidden="true" />
      {{ sectionTitle }}
    </h3>
    <div class="attachment-list">
      <a
        v-for="file in files"
        :key="file.url"
        :href="resolveAssetUrl(file.url)"
        target="_blank"
        rel="noopener noreferrer"
        class="attachment-link"
      >
        <i class="fa-regular fa-file-lines" aria-hidden="true" />
        <span>{{ getAttachmentName(file) }}</span>
      </a>
    </div>
  </section>
</template>

<style scoped>
.attachment-downloads {
  margin-top: 14px;
  padding: 12px;
  border: 0;
  border-radius: 12px;
  background: var(--bg);
}

.attachment-downloads h3 {
  margin: 0 0 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
}

.attachment-list {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.attachment-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--text);
  text-decoration: none;
  font-size: 14px;
  width: 100%;
  min-width: 0;
}

.attachment-link i {
  font-size: 15px;
  color: var(--text-soft);
  flex: 0 0 auto;
}

.attachment-link span {
  flex: 1 1 auto;
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
